import File from './File.vue';

export default File;



// WEBPACK FOOTER //
// ./src/pages/profile/blocks/form/components/file/index.ts